import Countdown from "./countdown.jsx"
import "../style/CarOverviewNotSpecial.css"
import { useNavigate } from 'react-router-dom';


function CarOverview(carro) {
    const navigate = useNavigate();
    const auctionCar = carro.carro?.Carro;

    // The populated Carro ref can be null when the underlying car has been
    // deleted. Render nothing rather than crashing the whole subastas grid.
    if (!auctionCar) return null;

    const firstImage = auctionCar.imagenes?.[0] || '';
    const backgroundurl = firstImage.replace("http://", "https://");

    const clickoverview = () => {
        navigate("/subasta/" + auctionCar._id)
    }

    function formatNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }



  return (
    <>
        <div onClick={clickoverview} style={{ '--background-image': `url(${backgroundurl})` }} className="car-updated-1-stock">
            {auctionCar.thirdPartySeller && (
              <span className="third-party-badge">Vendedor Externo</span>
            )}
            <div className="info-car-1-stock">
                <div className="info-part-stock">
                    {auctionCar.lote !== '0' && (<p className="lote" id="car-lote-h">Lote: {auctionCar.lote}</p>)}
                    <p className="car-model-stock">{auctionCar.marca} {auctionCar.modelo} {auctionCar.anio}</p>
                    <div className="price-block">
                      <span className="price-label">Precio inicial</span>
                      <p className="price-stock" translate="no">L.{formatNumberWithCommas(carro.carro.PrecioInicial)}</p>
                    </div>
                    <Countdown
                      startIso={carro.carro.Inicio}
                      endIso={carro.carro.Fin}
                    />

                </div>
            </div>
        </div>
    </>
  )
}

export default CarOverview
